import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'services/http.service';
import { FormMetricsCommentsPageModel } from 'services/models/form-builder/form-metrics/form-metrics-comments-page.model';
import { FormMetricsDashboardModel } from 'services/models/form-builder/form-metrics/form-metrics-dashboard.model';
import { FormMetricsFilter } from 'services/models/form-builder/form-metrics/form-metrics-filter.model';
import { buildFormMetricsHttpParams } from './form-metrics-http-params';

@Injectable({ providedIn: 'root' })
export class FormMetricsService {
  private readonly endpoint = 'formbuilder/metrics';
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpService) {}

  getDashboard(formId: string, filters?: FormMetricsFilter): Observable<FormMetricsDashboardModel> {
    const params = buildFormMetricsHttpParams(filters, { formId });

    return this.http
      .get(`${this.endpoint}/dashboard`, { params }, this.baseUrl, null, true)
      .pipe(map((res: any) => res.body as FormMetricsDashboardModel));
  }

  getComments(
    formId: string,
    formItemId: string,
    filters?: FormMetricsFilter,
    page: number = 1,
    pageSize: number = 20
  ): Observable<FormMetricsCommentsPageModel> {
    const params = buildFormMetricsHttpParams(filters, {
      formId,
      formItemId,
      page,
      pageSize,
    });

    return this.http
      .get(`${this.endpoint}/comments`, { params }, this.baseUrl, null, true)
      .pipe(map((res: any) => res.body as FormMetricsCommentsPageModel));
  }
}
